import React from 'react';

import {TEMPLATE_BULK_MONOMERS_CSV_LINK} from 'molbio/monomers/MonomerConstants';

import {createMonomersFromFile, validateMonomersFromFile} from '../MonomersDAO';
import MonomerConfigurationPageContainer from './MonomerConfigurationPageContainer';
import SharedMonomerCreateFromCSVPage from './SharedMonomerCreateFromCSVPage';

export default function MonomerCreateFromCSVPage(): JSX.Element {
  return (
    <SharedMonomerCreateFromCSVPage
      pageContainer={<MonomerConfigurationPageContainer methodTitle="Upload CSV" />}
      libraryUrl="/monomers"
      // Keep in sync with MONOMER_CSV_IMPORT_COLUMN_NAMES in benchling/molbio/monomers/constants.py
      bannerText='The CSV file must define “name”, “symbol”, "smiles", and “naturalAnalog" columns. It can also include an optional  "customMolecularWeight" column.'
      bannerSupportingInfo="Acceptable natural analog values include IUPAC bases, r, and p."
      templateCsvLink={TEMPLATE_BULK_MONOMERS_CSV_LINK}
      validate={validateMonomersFromFile}
      createFromFile={async (url) => (await createMonomersFromFile(url)).length}
      dataTestComponent="MonomerCreateFromCSVPage"
    />
  );
}
